import {
  createContext,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
} from "react";

export const PanelContext = createContext<{
  expandable: boolean;
  isLoading: boolean;
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
  containerRef: MutableRefObject<HTMLDivElement | null>;
}>({
  expandable: false,
  isLoading: false,
  expanded: true,
  setExpanded: () => {},
  containerRef: {
    current: null,
  },
});
